import { render, staticRenderFns } from "./text_extension.vue?vue&type=template&id=2da4d584&scoped=true&"
import script from "./text_extension.vue?vue&type=script&lang=js&"
export * from "./text_extension.vue?vue&type=script&lang=js&"
import style0 from "./text_extension.vue?vue&type=style&index=0&id=2da4d584&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da4d584",
  null
  
)

export default component.exports